import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getPincodes, deletePincode } from '@/api/pincode';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Inr from '@/components/Inr/index.vue';
import Enabled from '@/components/Enabled/index.vue';
import router from '@/router';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.cityId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      pincodeName: undefined,
      pincode: undefined,
      cityId: undefined,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        pincodeName: '$contL',
        pincode: '$contL',
        cityId: '$eq',
        enabled: '$eq'
      }
    };
    this.showCreatedDate = false;
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.cityId = parseInt(this.$route.params && this.$route.params.cityId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.cityId = this.cityId;
      const data = await getPincodes(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  handleDelete(data) {
    if (data) {
      this.$confirm(this.$tc('table.deleteConfirmation', undefined, {
        name: data.pincodeName
      }), this.$tc('table.delete'), {
        confirmButtonText: this.$tc('table.delete'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'Cancel',
        type: 'error'
      }).then(() => {
        deletePincode(data.id).then(deleted => {
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$tc('table.deleteCanceled')
        });
      });
    }
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
  edit(id = 0) {
    const query = this.listQuery;
    delete query.filter;
    router.push({
      path: '/pincode/edit/' + id,
      query
    });
  }
};
default_1 = __decorate([Component({
  name: 'PincodeList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;